export default __webpack_public_path__ + "23116caca3a6ad57cd96167f4483eeb6.woff2";